import { AppointmentConfirmation } from '../types/en-us'
import { ConfirmacaoAgendamento } from '../types/pt-br'

class GetAppointmentConfirmationData {
  toDomain(data: ConfirmacaoAgendamento): AppointmentConfirmation {
    return {
      dateScheduling: data?.dataAgendamento,
      pendingActivation: data?.flagPendenteAtivacao,
      professionalName: data?.nomeProfissional,
      url: data?.url,
      appointmentAlreadyConfirmed: data?.consultaJaConfirmada,
    }
  }
}

export default new GetAppointmentConfirmationData()
